import { pbrExt } from './fragments/subsurface-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrSubsurface(mat, subsurface) {
  mat._subsurface = subsurface;
  _registerPbrExt(pbrExt);
}

export { setPbrSubsurface };
//# sourceMappingURL=set-subsurface.js.map
